import React, { useEffect, useReducer, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';
// import { ICONS, Icon } from 'components/Icons';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import classnames from 'classnames';

import QuizQuestions from './../../../routes/Portfolio/Component/ChannelPage/components/QuizQuestions';

import './ArticleQuiz.scss';
import ActionLink from 'components/elements/molecules/ActionLink/ActionLink';
import { handleEvent } from 'helpers';
// import RadioGroup from 'components/elements/molecules/Radio/RadioGroup';
// import RadioOption from 'components/elements/molecules/Radio/RadioOption';

function ArticleQuiz({
  articleMediaCollectionId,
  courseId,
  topicId,
  user,
  // sourceURL,
  // pointId,
  actions,
}) {
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'SET_QUESTIONS':
          return {
            ...state,
            questions: action.payload.questions,
            pendingQuestions: action.payload.pendingQuestions,
          };
        case 'SET_QUIZ_QUESTION_INDEX':
          return {
            ...state,
            quizQuestionIndex: action.payload,
          };
        case 'SET_SHOW_QUESTION_FEEDBACK':
          return {
            ...state,
            showQuestionFeedback: action.payload.showQuestionFeedback,
            feedbackQuestionIndex: action.payload.feedbackQuestionIndex,
          };
        default:
          return state;
      }
    },
    {
      quizQuestionIndex: 0,
      showQuestionFeedback: false,
      feedbackQuestionIndex: -1,
    },
  );

  const [quizLoadedFromServer, setQuizLoadedFromServer] = useState(false);

  useEffect(() => {
    handleEvent('QUIZ_STARTED', {
      articleMediaCollectionId,
      topicId,
    });
    loadQuizQuestions();
    document.body.style.backgroundColor = '#fff';
  }, []);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (window.parent) {
          setTimeout(() => {
            window.parent.postMessage(
              {
                type: 'averpoint:request:setHeight',
                height: entry.target.scrollHeight,
              },
              '*',
            );
          }, 0);
        }
      }
    });

    observer.observe(document.body);
  }, [state.questions, state.quizQuestionIndex, state.showQuestionFeedback]);

  useEffect(() => {
    function onMessage(event) {
      const data = event.data;

      if (data.type === 'averpoint:articleQuiz:request') {
        const questions = data.data.quiz.questions;
        dispatch({
          type: 'SET_QUESTIONS',
          payload: { questions, pendingQuestions: [...questions] },
        });
      }
    }

    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!state.questions) {
        setQuizLoadedFromServer(true);
        loadQuizQuestionsFromServer();
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, [state.questions]);

  function onClose() {
    if (!window.parent) {
      return;
    }

    window.parent.postMessage(
      {
        type: 'averpoint:articleQuiz:close',
      },
      '*',
    );
  }

  function onSubmit() {
    if (quizLoadedFromServer) {
      loadQuizQuestionsFromServer();
    }

    if (!window.parent) {
      return;
    }

    window.parent.postMessage(
      {
        type: 'averpoint:articleQuiz:submitted',
      },
      '*',
    );
  }

  function loadQuizQuestions() {
    if (!window.parent) {
      return;
    }

    window.parent.postMessage(
      {
        type: 'averpoint:articleQuiz:request',
      },
      '*',
    );
  }

  async function loadQuizQuestionsFromServer() {
    // if (articleMediaCollectionId && courseId && topicId) {
    const res = await actions.getQuizQuestionsForArticle(
      articleMediaCollectionId,
      courseId,
      topicId,
    );
    const questions = res.questions.filter(
      (i) => i.typeOfQuestion !== 'comprehension' || i.type === 'SINGLE_CHOICE',
    );
    // const topicGoals = await actions.getTopicGoals(
    //   topicId,
    //   courseId,
    //   false,
    //   true,
    // );
    // const readingQuestions = topicGoals.readingStatistics.find(
    //   (i) => i.pointId === articleMediaCollectionId,
    // ).questions;
    // questions.forEach((question) => {
    //   question.rightAnswers = readingQuestions.find(
    //     (i) => i.text === question.text,
    //   ).answers;
    // });
    // const pendingQuestions = questions.filter((i) => !i.rightAnswers);
    // // const pendingQuestions = [...questions];
    dispatch({
      type: 'SET_QUESTIONS',
      payload: { questions, pendingQuestions: [...questions] },
    });

    // } else {
    //   const res = await actions.generateQuestionsFromSource(sourceURL, pointId);
    //   const questions = res.map((i) => ({
    //     text: i.text,
    //     type: i.options && i.options.length ? 'SINGLE_CHOICE' : 'SHORT_ANSWER',
    //     options: i.options,
    //     _id: i._id,
    //   }));
    //   const pendingQuestions = [];
    //   for (let i = 0; i < questions.length; i++) {
    //     try {
    //       const res = await actions.checkForQuestionAttempt(questions[i]._id);

    //       if (!res.hasAlreadyAnswered) {
    //         pendingQuestions.push(questions[i]);
    //       }
    //     } catch {}
    //   }
    //   dispatch({
    //     type: 'SET_QUESTIONS',
    //     payload: { questions: questions, pendingQuestions: pendingQuestions },
    //   });
    // }
  }

  function renderQuestions() {
    if (
      state.showQuestionFeedback ||
      !state.questions ||
      !state.questions.length ||
      state.quizQuestionIndex >= state.questions.length
    ) {
      return null;
    }

    // const question = state.pendingQuestions[state.quizQuestionIndex];
    const question = state.questions[state.quizQuestionIndex];
    return (
      <div className="quiz-question">
        <QuizQuestions
          key={question._id}
          question={question}
          onNext={() => {
            dispatch({
              type: 'SET_QUIZ_QUESTION_INDEX',
              payload: state.quizQuestionIndex + 1,
            });
          }}
          onPrevious={() => {
            dispatch({
              type: 'SET_QUIZ_QUESTION_INDEX',
              payload: state.quizQuestionIndex - 1,
            });
          }}
          articleMediaCollectionId={articleMediaCollectionId}
          // courseId={courseId}
          topicId={topicId}
          quizQuestionIndex={state.quizQuestionIndex}
          // pendingQuestions={state.pendingQuestions}
          pendingQuestions={state.questions}
          readOnly={question.userAnswer && question.userAnswer.isSubmitted}
          onFeedback={() => {
            dispatch({
              type: 'SET_SHOW_QUESTION_FEEDBACK',
              payload: {
                showQuestionFeedback: true,
                feedbackQuestionIndex: state.quizQuestionIndex,
              },
            });
          }}
        />
      </div>
    );
  }

  function showAnswer(question) {
    if (question.userAnswer) {
      const answer = question.userAnswer.answers[0];
      return answer.text || answer;
    }

    if (!Array.isArray(question.answers) || !question.answers.length) {
      return null;
    }

    if (!Array.isArray(question.options) || !question.options.length) {
      if (isNaN(question.answers[0])) {
        return question.answers[0];
      }

      return null;
    }

    if (!question.options[question.answers[0]]) {
      return null;
    }

    return question.options[question.answers[0]].text;
  }

  function renderSubmitQuizBtn() {
    if (
      !state.questions ||
      !state.questions.filter((i) => !i.userAnswer || !i.userAnswer.isSubmitted)
        .length
    ) {
      return null;
    }

    return (
      <div className="text-right">
        <RectangularButton
          className="white-button"
          size="small"
          onClick={async () => {
            try {
              handleEvent('QUIZ_SUBMITTED', {
                articleMediaCollectionId,
                topicId,
              });
              await actions.submitQuiz(articleMediaCollectionId, topicId);
              loadQuizQuestions();
              onSubmit();
            } catch (e) {
              handleEvent('QUIZ_SUBMITTED_ERROR', {
                error: e,
              });
            }
          }}
        >
          Submit
        </RectangularButton>
      </div>
    );
  }

  function renderDoneBtn() {
    if (
      !state.questions ||
      state.questions.filter((i) => !i.userAnswer || !i.userAnswer.isSubmitted)
        .length
    ) {
      return null;
    }

    return (
      <div className="text-right">
        <RectangularButton
          className="white-button"
          size="small"
          onClick={() => {
            onSubmit();
            onClose();
          }}
        >
          Done
        </RectangularButton>
      </div>
    );
  }

  function renderQuizResultSummary() {
    const totalQuestions = state.questions.length;
    const submittedQuestions = state.questions.filter(
      (i) => i.userAnswer && i.userAnswer.isSubmitted,
    );

    if (totalQuestions !== submittedQuestions.length) {
      return null;
    }

    const verifiedAnswers = state.questions.filter(
      (question) => question.options && question.options.length,
    );
    const isStudent =
      user && user.profile.roles.some((r) => r.type === 'student');

    return (
      <p>
        {verifiedAnswers.length > 0 && (
          <span className="mr-2">
            You correctly answered{' '}
            {
              verifiedAnswers.filter(
                (i) => i.userAnswer && i.userAnswer.isCorrect,
              ).length
            }{' '}
            of {verifiedAnswers.length} questions.
          </span>
        )}
        {verifiedAnswers.length !== totalQuestions && isStudent && (
          <span>
            You answered {totalQuestions - verifiedAnswers.length} questions
            that your teacher will review.
          </span>
        )}
        {verifiedAnswers.length !== totalQuestions && !isStudent && (
          <span>
            You answered {totalQuestions - verifiedAnswers.length} short answer
            questions. Our team will review your answers.
          </span>
        )}
      </p>
    );
  }

  function renderCompleteMessage() {
    if (
      state.showQuestionFeedback ||
      !state.questions ||
      !state.questions.length ||
      state.quizQuestionIndex < state.questions.length
    ) {
      return null;
    }

    // const submittedQuestions = state.questions.filter(
    //   (i) => i.userAnswer && i.userAnswer.isSubmitted,
    // );

    // if (submittedQuestions.length === state.questions.length) {
    //   return (
    //     <h3 className="font-weight-600 m-0 text-center">
    //       Thanks for taking Quiz
    //     </h3>
    //   );
    // }

    return (
      <div className="">
        <div className="d-flex align-items-center">
          <h3 className="font-weight-600 m-0">Your answers</h3>
        </div>
        {renderQuizResultSummary()}

        {/* <RectangularButton
          className="mt-4 mb-4"
          onClick={() => {
            onClose();
          }}
        >
          Close
        </RectangularButton> */}
        {state.questions.map((question, index) => {
          if (
            question.typeOfQuestion !== 'comprehension' ||
            question.type === 'SINGLE_CHOICE'
          ) {
            // const correctOptionIndex = question.options.findIndex(
            //   (i) => i.isCorrect,
            // );
            return (
              <div className="question-summary">
                <div className="question-text">{question.text}</div>
                <div className="your-answer">
                  <div className="d-flex align-items-center">
                    Your Answer:
                    {/* {question.isCorrect ? (
                      <Icon icon={ICONS.CHECK} className="ml-2 correct" />
                    ) : (
                      <Icon icon={ICONS.CLOSE} className="ml-2 wrong" />
                    )} */}
                  </div>
                  {renderQuestionAnswer(question)}
                </div>
                {renderQuestionCorrectAnswer(question)}
                {renderQuestionFeedbackBtn(question, index)}
              </div>
            );
          }
        })}
        {renderDoneBtn()}
        {renderSubmitQuizBtn()}
      </div>
    );
  }

  function renderQuestionAnswer(question) {
    const className = classnames('answer', {
      correct:
        question.userAnswer &&
        question.userAnswer.isCorrect &&
        question.userAnswer.isSubmitted,
      wrong:
        question.userAnswer &&
        question.options &&
        question.options.length &&
        !question.userAnswer.isCorrect &&
        question.userAnswer.isSubmitted,
    });

    return <div className={className}>{showAnswer(question)}</div>;
  }

  function renderQuestionCorrectAnswer(question) {
    if (
      question.requiresManualVerification ||
      !question.userAnswer ||
      !question.userAnswer.isSubmitted ||
      question.userAnswer.isCorrect ||
      !question.options ||
      !question.options.length
    ) {
      return null;
    }

    return (
      <div className="correct-answer">
        <div>Correct Answer:</div>
        <div className="answer correct">
          {question.options[question.correctAnswer[0]].text}
        </div>
      </div>
    );
  }

  function renderQuestionFeedbackBtn(question, index) {
    if (!question.userAnswer || !question.userAnswer.isSubmitted) {
      return null;
    }

    return (
      <div className="d-flex mt-2">
        <ActionLink
          onClick={async () => {
            dispatch({
              type: 'SET_SHOW_QUESTION_FEEDBACK',
              payload: {
                showQuestionFeedback: true,
                feedbackQuestionIndex: index,
              },
            });
          }}
          linkClassName="av-blue ml-auto"
          label="Feedback"
        />
      </div>
    );
  }

  function renderQuestionFeedback() {
    if (!state.showQuestionFeedback || !state.questions) {
      return null;
    }

    const question = state.questions[state.feedbackQuestionIndex];

    if (!question) {
      return null;
    }

    return (
      <QuestionFeeback
        question={question}
        onClose={() => {
          dispatch({
            type: 'SET_SHOW_QUESTION_FEEDBACK',
            payload: {
              showQuestionFeedback: false,
            },
          });
        }}
        actions={actions}
        articleMediaCollectionId={articleMediaCollectionId}
        topicId={topicId}
      />
    );
  }

  return (
    <div className="route-article-quiz">
      {renderQuestions()}
      {renderCompleteMessage()}
      {renderQuestionFeedback()}
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  const params = new URLSearchParams(ownProps.location.search);
  const articleMediaCollectionId = params.get('articleMediaCollectionId');
  const courseId = params.get('courseId');
  const topicId = params.get('topicId');
  // const sourceURL = params.get('sourceURL');
  // const pointId = params.get('pointId');

  return {
    articleMediaCollectionId,
    courseId,
    topicId,
    user: state.user.user,
    // sourceURL,
    // pointId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ArticleQuiz),
);

export function QuestionFeeback({
  question,
  onClose,
  actions,
  articleMediaCollectionId,
  topicId,
  isChannelPageQuiz,
}) {
  const [userReview, setUserReview] = useState('good');
  const [reason, setReason] = useState('');
  const [supportingText, setSupportingText] = useState('');
  const [submitted, setSubmitted] = useState(false);
  return (
    <div className="">
      {/* <div className="d-flex align-items-center">
        <h3 className="font-weight-600 m-0">Question Feedback</h3>
      </div> */}
      <div className="">
        <div className="font-weight-600 font-size-14">Question</div>
        <div className="question-text border-bottom pb-3 mt-1">
          {question.text}
        </div>
        <div className="mt-3 font-weight-600">
          <span>How was the question?</span>
          <ActionLink
            label="good"
            linkClassName={`ml-2 ${userReview === 'good' ? 'av-blue' : ''}`}
            onClick={() => {
              setUserReview('good');
            }}
          />
          <ActionLink
            label="bad"
            linkClassName={`ml-2 ${userReview === 'bad' ? 'av-red' : ''}`}
            onClick={() => {
              setUserReview('bad');
            }}
          />
        </div>
        {/* <RadioGroup
          className="d-flex align-items-center"
          handleChange={(e) => {
            setUserReview(e.target.value);
          }}
        >
          <RadioOption
            name="questionFeedbackOption"
            id="good"
            value="good"
            label="Good"
            checked={userReview === 'good'}
          ></RadioOption>
          <RadioOption
            name="questionFeedbackOption"
            id="bad"
            value="bad"
            label="Bad"
            className="ml-4"
            checked={userReview === 'bad'}
          ></RadioOption>
        </RadioGroup> */}
        <div className="mt-3 mb-1">Your Reason</div>
        <textarea
          type="text"
          className="form-control question-text-input mt-2"
          placeholder="type here"
          onChange={(e) => {
            setReason(e.target.value);
          }}
          value={reason}
        ></textarea>
        {/* <textarea
          type="text"
          className="form-control question-text-input mt-2"
          placeholder="More detail"
          onChange={(e) => {
            setSupportingText(e.target.value);
          }}
          value={supportingText}
        ></textarea> */}
        {submitted ? (
          <div
            className={`mt-4 ${
              !isChannelPageQuiz ? 'text-center' : 'text-left'
            }`}
          >
            <div
              className="fa fa-spin fa-spinner text-primary mr-2"
              style={{ fontSize: '20px' }}
            />
          </div>
        ) : (
          <RectangularButton
            className={`${
              !isChannelPageQuiz ? 'w-100' : ''
            } dark-button py-2 mt-4 font-size-14 font-weight-600`}
            onClick={async () => {
              handleEvent('QUIZ_QUESTION_FEEDBACK', {
                questionId: question._id,
                questionText: question.text,
                userReview,
                reason,
                supportingText,
                articleMediaCollectionId,
                topicId,
              });
              try {
                setSubmitted(true);
                const req = {
                  questionId: question._id,
                  userReview,
                  reason,
                  supportingText,
                };
                await actions.raisedDisputeOnQuizQuestion(req);
                onClose();
              } catch {
              } finally {
                setSubmitted(false);
              }
            }}
          >
            Submit
          </RectangularButton>
        )}
        {!isChannelPageQuiz && (
          <div className="question-feedback-footer mt-4 text-right">
            <ActionLink
              onClick={async () => {
                onClose(true);
              }}
              linkClassName="av-blue mt-2"
              label="Back to quiz"
            />
            {/* {submitted ? (
                <div
                  className="fa fa-spin fa-spinner text-primary mr-2"
                  style={{ fontSize: '20px' }}
                />
              ) : (
                <ActionLink
                  onClick={async () => {
                    try {
                      setSubmitted(true);
                      const req = {
                        questionId: question._id,
                        userReview,
                        reason,
                        supportingText,
                      };
                      await actions.raisedDisputeOnQuizQuestion(req);
                      onClose();
                    } catch {
                    } finally {
                      setSubmitted(false);
                    }
                  }}
                  linkClassName="av-blue"
                  label="Submit"
                />
              )} */}
          </div>
        )}
      </div>
    </div>
  );
}
